import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(`customer/reporting/process/list_processes/${customer_id}/agro_exporter/${agro_exporter_id}`)
  },
  fetchAgroExporterProcesses(customer_id, agro_exporter_id) {
    return RequesterV1.get(
      `customer/reporting/process/list_processes/${customer_id}/${agro_exporter_id}`
    );
  }
};
